module.exports = __webpack_public_path__ + "static/img/sdwyj_img4.07f1981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sdwyj_img4.png
// module id = yNFu
// module chunks = 1